import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { MomMinutesOfMeetingService } from 'src/app/services/mom-minutes-of-meeting.service';

@Component({
  selector: 'app-mom-meeting-type',
  templateUrl: './mom-meeting-type.component.html',
  styleUrls: ['./mom-meeting-type.component.scss']
})
export class MomMeetingTypeComponent implements OnInit {

  mode:any
  @ViewChild('editor') editor:any;
  description:any = "<p><b>Lorem ipsum</b> dolor sit amet, <s>consectetur adipiscing elit</s>, sed do eiusmod tempor <u>incididunt</u> ut labore et dolore <i>magna aliqua</i>.";

  addMeetingTypeForm!: FormGroup

  meetingList:any
  meetingTypeId:any
  role:any = []
  action:string = 'save'

  constructor(private activatedRoute: ActivatedRoute, private formBuilder: FormBuilder, private router: Router,
    private momMinutesOfMeetingService: MomMinutesOfMeetingService, private dialog: MatDialog,
    ){
    console.log(activatedRoute.params, )
    this.activatedRoute.params.subscribe((res:any)=>{
      this.mode = res.mode
      console.log(this.mode)
    })

    this.addMeetingTypeForm = this.formBuilder.group({
      meetingType: ['', Validators.required]
    })

    console.log(localStorage.getItem('roles'));

    this.role = localStorage.getItem('roles').split(',');
  }

  ngOnInit(): void {
    if(this.mode === 'view'){
      this.getMeetingTypeList()
    }
  }

  checkAuthority(role: string){
    let isTrue:boolean = false
    this.role.forEach((element:string) => {
      if(element === role) isTrue = true
    });
    return isTrue
  }

  deleteMeetingType(meetingTypeId:any){
    this.momMinutesOfMeetingService.deleteMeetingType(meetingTypeId)
    .subscribe((res:any)=>{
      if(!res){
        this.dialog.closeAll()
        this.getMeetingTypeList()
        this.momMinutesOfMeetingService.successToast('Meeting Deleted Successfuly');
      }
      else{
        this.dialog.closeAll()
      }
    })
  }

  addMeetingType(){
    let body ={
      "meetingType": this.addMeetingTypeForm.value.meetingType
    }

    this.momMinutesOfMeetingService.saveMeetingType(body)
    .subscribe((res:any)=>{
      this.dialog.closeAll()
      if(res.id){
        this.addMeetingTypeForm.reset()
        this.router.navigate(['/secure/mom-meeting-type/view', 'view'])
        this.momMinutesOfMeetingService.successToast('Meeting Added Successfuly');
      }
      else{
        this.momMinutesOfMeetingService.errorToast('Error Occured');
      }
    })
  }

  getMeetingTypeList(){
    this.momMinutesOfMeetingService.getMeetingTypes()
    .subscribe((res:any)=>{
      console.log('meetingList  ::::: ', res)
      this.meetingList = res
    })
  }

  opneConfirmationModal(templateRef: TemplateRef<any>, id:any, action:string){
    this.action = action
    this.meetingTypeId = id
    this.dialog.open(templateRef, {
      width: '30%',
      // height: '15%',
      hasBackdrop: false
    })
  }

  goToList() {
    this.router.navigate(['/secure/mom-meeting-type/view']);
  }

  editBorad(meetingTypeId:number){
    this.dialog.closeAll()
    this.router.navigate(['/secure/mom-meeting-type/edit-meeting-type/edit', {id: meetingTypeId}])
  }

  setStyle(style: string) {
    let bool = document.execCommand(style, false, '');
  }

}
